import { render, staticRenderFns } from "./editpushbuttonalert.vue?vue&type=template&id=636ea4e9&scoped=true"
import script from "./editpushbuttonalert.vue?vue&type=script&lang=js"
export * from "./editpushbuttonalert.vue?vue&type=script&lang=js"
import style0 from "./editpushbuttonalert.vue?vue&type=style&index=0&id=636ea4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ea4e9",
  null
  
)

export default component.exports